;(function(win) {
  win._webUrl = ''
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    console.log('to mobile')
    // to mobile
    win.location.href = `${win._webUrl}/mobile/#/`
  }

  // geoserver 地址前缀
  win.geoServerUrlPre = 'https://www.fjscyzgl.com:8081'
})(window)

export const GLOBAL_CONFIG = {
  /**
   * 当前项目部署地址
   */
  ONLINE_URL: 'https://www.fjscyzgl.com' // 正式环境
  // ONLINE_URL: 'http://192.168.2.17:1257' // 测试环境
}
